module.exports = __webpack_public_path__ + "img/tt.ce223ef8.svg";